// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-input[data-v-81e6a242]{font-family:var(--font-main);align-items:center;border:1px solid var(--border);border-radius:var(--round-corner-small);display:flex;flex-grow:1;font-size:var(--font-size-16);padding:0 var(--space-16);margin:0;-webkit-appearance:none;appearance:none}.text-input.invalid[data-v-81e6a242]{border-color:var(--red)!important}", ""]);
// Exports
module.exports = exports;
